import en from "./locales/en.json";
import pl from "./locales/pl.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import ar from "./locales/ar.json";
import sr from "./locales/sr.json";
import sr_cyr from "./locales/sr_cyr.json";
import ja from "./locales/ja.json";
export var locales = {
    en: en,
    pl: pl,
    es: es,
    de: de,
    it: it,
    pt: pt,
    fr: fr,
    ar: ar,
    sr: sr,
    sr_cyr: sr_cyr,
    ja: ja,
};
export var defaultLanguage = "en";
